import { render } from "./AllTccView.vue?vue&type=template&id=5008a5d7&scoped=true"
import script from "./AllTccView.vue?vue&type=script&lang=js"
export * from "./AllTccView.vue?vue&type=script&lang=js"

import "./AllTccView.vue?vue&type=style&index=0&id=5008a5d7&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5008a5d7"]])

export default __exports__